import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-7 col-md-7 col-sm-12 col-12" }
const _hoisted_3 = { class: "custom-input-group mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "input-group-text",
  style: {"border-top-left-radius":"0","border-bottom-left-radius":"0","border-left-width":"0"}
}
const _hoisted_5 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M22,3H7C6.31,3 5.77,3.35 5.41,3.88L0,12L5.41,20.11C5.77,20.64 6.31,21 7,21H22A2,2 0 0,0 24,19V5A2,2 0 0,0 22,3M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12"
  })
], -1)
const _hoisted_7 = { class: "col-lg-3 col-md-3 col-sm-12 col-12" }
const _hoisted_8 = { class: "input-group mb-3" }
const _hoisted_9 = /*#__PURE__*/_createVNode("option", { value: 10 }, "Max 10 rows", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("option", { value: 20 }, "Max 20 rows", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("option", { value: 30 }, "Max 30 rows", -1)
const _hoisted_12 = { class: "input-group-append" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Retry ")
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fas fa-sync-alt" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" No pending deposits. ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Loading pending deposits data. Please wait. ")
const _hoisted_17 = { style: {"width":"80px","text-align":"right"} }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "text-muted" }, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-edit" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "text-muted" }, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-edit" })
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "fas fa-sync-alt" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "fas fa-search fa-sm" }, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "table text-left details-table"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("td", {
  class: "table-list-header",
  style: {"border-top-width":"0","padding-top":"0"}
}, " Uuid ", -1)
const _hoisted_25 = {
  class: "table-list-value",
  style: {"border-top-width":"0","padding-top":"0"}
}
const _hoisted_26 = { style: {"color":"#848696"} }
const _hoisted_27 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Customer", -1)
const _hoisted_28 = { class: "table-list-value" }
const _hoisted_29 = /*#__PURE__*/_createVNode("td", {
  class: "table-list-header",
  style: {"border-top-width":"0","padding-top":"0"}
}, null, -1)
const _hoisted_30 = {
  class: "table-list-value",
  style: {"border-top-width":"0","padding-top":"0"}
}
const _hoisted_31 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Amount", -1)
const _hoisted_32 = { class: "table-list-value" }
const _hoisted_33 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Currency", -1)
const _hoisted_34 = { class: "table-list-value" }
const _hoisted_35 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Created At", -1)
const _hoisted_36 = { class: "table-list-value" }
const _hoisted_37 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Status", -1)
const _hoisted_38 = { class: "table-list-value" }
const _hoisted_39 = {
  key: 0,
  class: "badge badge-light badge-status"
}
const _hoisted_40 = {
  key: 1,
  class: "badge badge-success badge-status"
}
const _hoisted_41 = {
  key: 2,
  class: "badge badge-danger badge-status"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Evidence", -1)
const _hoisted_43 = { class: "table-list-value" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Download ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_amountInput = _resolveComponent("amountInput")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", null, [
      _createVNode(_component_DataTable, {
        editMode: "cell",
        value: _ctx.getMissingDeposits,
        paginator: true,
        rows: 10,
        rowsPerPageOptions: [10, 20, 50],
        autoLayout: true,
        filterDisplay: "menu",
        loading: _ctx.status == 'fetching',
        paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
        currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
        filters: _ctx.filters,
        "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters = $event)),
        globalFilterFields: ['customer.fullName', 'currencyId', 'createdAt']
      }, {
        header: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _withDirectives(_createVNode("input", {
                  autofocus: "",
                  type: "text",
                  class: "form-control",
                  placeholder: "Type to search...",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event))
                }, null, 512), [
                  [_vModelText, _ctx.filters['global'].value]
                ]),
                (!_ctx.filters['global'].value)
                  ? (_openBlock(), _createBlock("span", _hoisted_4, [
                      _hoisted_5
                    ]))
                  : (_openBlock(), _createBlock("span", {
                      key: 1,
                      class: "input-group-text",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearFilter()))
                    }, [
                      _hoisted_6
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.maxRows = $event)),
                  class: "form-control"
                }, [
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11
                ], 512), [
                  [_vModelSelect, _ctx.maxRows]
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("button", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.retryFillAllReferencesValues && _ctx.retryFillAllReferencesValues(...args))),
                    class: "btn btn-sm btn-warning"
                  }, [
                    _hoisted_13,
                    _hoisted_14
                  ])
                ])
              ])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _hoisted_15
        ]),
        loading: _withCtx(() => [
          _hoisted_16
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            filterField: "customerFullName",
            header: "User",
            bodyStyle: "text-align: left"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.customer.firstName) + " " + _toDisplayString(slotProps.data.customer.lastName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "amount",
            header: "Amount",
            headerStyle: "text-align: right",
            bodyStyle: "text-align: right"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.currency.currencyType === 1
                ? '$ ' + _ctx.formatPrice(slotProps.data.amount)
                : _ctx.formatZeros(
                    slotProps.data.amount,
                    slotProps.data.currency.exact
                  )), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            filterField: "currencyId",
            header: "Currency"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("span", _hoisted_17, _toDisplayString(slotProps.data.currencyId), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            filterField: "createdAt",
            header: "Accounting Hour"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdAt)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "CAD Value" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(" $ " + _toDisplayString(_ctx.formatPrice(slotProps.data.cadExchangeValue)) + " ", 1),
              _hoisted_18
            ]),
            editor: _withCtx((slotProps) => [
              _createVNode(_component_amountInput, {
                "onUpdate:amount": ($event: any) => (
                slotProps.data['cadExchangeValue'] = parseFloat($event)
              ),
                amount: slotProps.data['cadExchangeValue'],
                precision: 2
              }, null, 8, ["onUpdate:amount", "amount"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "USD Value" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(" $ " + _toDisplayString(_ctx.formatPrice(slotProps.data.usdExchangeValue)) + " ", 1),
              _hoisted_19
            ]),
            editor: _withCtx((slotProps) => [
              _createVNode(_component_amountInput, {
                "onUpdate:amount": ($event: any) => (
                slotProps.data['usdExchangeValue'] = parseFloat($event)
              ),
                amount: slotProps.data['usdExchangeValue'],
                precision: 2
              }, null, 8, ["onUpdate:amount", "amount"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "quantity",
            header: "Action",
            headerStyle: "text-align:center"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode("div", null, [
                _createVNode("button", {
                  onClick: ($event: any) => (
                  _ctx.retryFillReferenceValues(slotProps.index, slotProps.data)
                ),
                  disabled: 
                  (slotProps.data.cadExchangeValue &&
                    slotProps.data.usdExchangeValue) ||
                    (_ctx.isLoadingRetry && _ctx.indexFilling === slotProps.index)
                ,
                  class: "ml-3 btn btn-sm btn-warning"
                }, [
                  _hoisted_20
                ], 8, ["onClick", "disabled"]),
                _createVNode("button", {
                  onClick: e => _ctx.saveDeposit(e, slotProps.data),
                  disabled: !slotProps.data.cadExchangeValue || _ctx.isLoading,
                  class: "ml-1 btn btn-sm btn-success"
                }, [
                  _hoisted_21
                ], 8, ["onClick", "disabled"]),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-outline-info btn-sm ml-1",
                  disabled: 
                  _ctx.manageDepositStatus == 'fetching' &&
                    _ctx.manageDepositId == slotProps.data.id
                ,
                  onClick: ($event: any) => (_ctx.getDepositDetails(slotProps.data.id))
                }, [
                  _hoisted_22
                ], 8, ["disabled", "onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading", "filters", "globalFilterFields"]),
      _createVNode(_component_ConfirmPopup)
    ]),
    _createVNode(_component_Modal, {
      show: _ctx.showDetailsModal,
      onOk: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDetailsModal = false)),
      title: 'Deposit details',
      rightHeaderBadge: '#' + _ctx.depositDetails?.id,
      showCancelButton: false,
      size: "lg",
      okText: "Close",
      okButtonClass: "btn-secondary"
    }, {
      default: _withCtx(() => [
        (_ctx.depositDetails)
          ? (_openBlock(), _createBlock("table", _hoisted_23, [
              _createVNode("tr", null, [
                _hoisted_24,
                _createVNode("td", _hoisted_25, [
                  _createVNode("code", _hoisted_26, _toDisplayString(_ctx.depositDetails.uuid), 1)
                ])
              ]),
              _createVNode("tr", null, [
                _hoisted_27,
                _createVNode("td", _hoisted_28, _toDisplayString(_ctx.depositDetails.customer.firstName) + " " + _toDisplayString(_ctx.depositDetails.customer.lastName), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_29,
                _createVNode("td", _hoisted_30, _toDisplayString(_ctx.hideEmail(_ctx.depositDetails.customer.email)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_31,
                _createVNode("td", _hoisted_32, " $ " + _toDisplayString(_ctx.formatPrice(_ctx.depositDetails.amount)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_33,
                _createVNode("td", _hoisted_34, _toDisplayString(_ctx.depositDetails.currencyId), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_35,
                _createVNode("td", _hoisted_36, _toDisplayString(_ctx.formatDate(_ctx.depositDetails.createdAt)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_37,
                _createVNode("td", _hoisted_38, [
                  (_ctx.depositDetails.status == 1)
                    ? (_openBlock(), _createBlock("span", _hoisted_39, " Pending "))
                    : (_ctx.depositDetails.status == 2)
                      ? (_openBlock(), _createBlock("span", _hoisted_40, " Authorized "))
                      : (_ctx.depositDetails.status == 3)
                        ? (_openBlock(), _createBlock("span", _hoisted_41, " Rejected "))
                        : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("tr", null, [
                _hoisted_42,
                _createVNode("td", _hoisted_43, [
                  (!_ctx.depositDetails.files[0])
                    ? (_openBlock(), _createBlock("div", _hoisted_44, "No evidence provied"))
                    : (_openBlock(), _createBlock("div", _hoisted_45, [
                        _createVNode("button", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadDocument(_ctx.depositDetails.files[0]))),
                          class: "btn btn-sm btn-primary"
                        }, [
                          _hoisted_46,
                          _hoisted_47
                        ])
                      ]))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show", "rightHeaderBadge"])
  ]))
}